/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalContent, ModalHeader, Button, Text, Space, RadioGroup, Popup, Conditional, InputField, Dropdown } from '@cashfree-intl/coherent';
import Loader from 'components/Loader';

import FormikComponent from 'components/Formik';
import CustomIcon from 'components/CustomIcons';
import { previewFile, copyToClipboard } from 'utils/common';
import FileUploadArea from 'components/FileUploadArea';
import { StyledBusinessTypeDropdown } from 'containers/Vendors/styled';
import kycFormvalidationSchema from './Validations/KycFormValidation';

import {
  BUSINESS_TYPE_MAPPING,
  DOCS_ADDRESS_MAPPING,
  POSSIBLE_KYC_PAYLOAD,
  RELATED_DOCS_INPUT_MAPPING,
  POSSIBLE_KYC_DOCS,
  POSSIBLE_BUSINESS_FIELDS,
  POSSIBLE_INDIVIDUAL_FIELDS,
  DOC_VALUES_ON_ADDRESS,
  ADDRESS_DOCS_API_RESPONSE,
  GENERAL_FILE_CHECKLIST,
  VALID_FILE_FORMATS,
  BUSINESS_TYPE_OPTION,
  ADDRESS_PROOF_OPTIONS,
  POSSIBLE_INDIVIDUAL_DOCS,
  POSSIBLE_BUSINESS_DOCS,
  VENDOR_TYPE_RADIO_DATA,
  RENDER_INDIVIDUAL_FORM,
  RENDER_BUSINESS_FORM,
  INDIVIDUAL,
  BUSINESS,
  PAN,
  NBFC_CERTIFICATE,
  NBFC_TEXT,
  PAN_NUMBER,
  PAN_NAME,
  BUSINESS_PAN,
  BUSINESS_PAN_DOC,
  FILE_SIZE,
  SAMPLE_REGEX_INPUT_MAPPING,
} from '../../../constants';

let isDocUploaded = true;
const isDocsUploadedFunction = (
  fileObj,
  businessType,
  addressProof,
  accountType,
) => {
  if (accountType === BUSINESS) {
    // eslint-disable-next-line consistent-return
    POSSIBLE_BUSINESS_DOCS.forEach(doc => {
      if (doc !== NBFC_CERTIFICATE) {
        if (!fileObj[doc].name) {
          isDocUploaded = false;
        }
      }
    });
  } else {
    if (!fileObj.PAN.name) isDocUploaded = false;
    const docs = DOCS_ADDRESS_MAPPING[addressProof];
    // eslint-disable-next-line consistent-return
    if (docs)
      docs.forEach(doc => {
        if (!fileObj[doc].name) isDocUploaded = false;
      });
  }
  if (
    BUSINESS_TYPE_MAPPING[businessType] === NBFC_TEXT &&
    !fileObj.NBFC_CERTIFICATE.name
  ) {
    isDocUploaded = false;
  }
};

const filterUpdatedPayloadOnAccountType = (payload, accountType) => {
  const filteredPayload = payload;
  if (accountType === INDIVIDUAL) {
    POSSIBLE_BUSINESS_FIELDS.forEach(field => {
      filteredPayload[field] = '';
    });
  } else {
    POSSIBLE_INDIVIDUAL_FIELDS.forEach(field => {
      filteredPayload[field] = '';
    });
  }
  return filteredPayload;
};

const filterUpdatedPayloadDocs = (payload, addressProof, accountType) => {
  const filteredPayload = payload;
  if (accountType === BUSINESS) {
    POSSIBLE_INDIVIDUAL_DOCS.forEach(docName => {
      filteredPayload.completeFileObj[docName] = {};
    });
    filteredPayload.completeFileObj.PAN =
      filteredPayload.completeFileObj.businessPanDoc;
    filteredPayload.completeFileObj.businessPanDoc = {};
  } else {
    POSSIBLE_BUSINESS_DOCS.forEach(docName => {
      filteredPayload.completeFileObj[docName] = {};
    });
    DOC_VALUES_ON_ADDRESS.forEach((docNames, i) => {
      if (i !== addressProof - 1) {
        docNames.forEach(doc => {
          filteredPayload.completeFileObj[doc] = {};
        });
      }
    });
  }
  if (payload.businessType !== NBFC_TEXT) {
    filteredPayload.completeFileObj.NBFC_CERTIFICATE = {};
  }
  return filteredPayload;
};

const filterUpdatedPayloadOnAddress = (payload, addressProof) => {
  const filteredPayload = payload;
  POSSIBLE_INDIVIDUAL_FIELDS.forEach((field, i) => {
    if (i !== addressProof - 1) filteredPayload[field] = '';
  });
  return filteredPayload;
};

const initialTouchedObj = {};
const initialErrorObj = {};

const populateKycInputFields = data => {
  if (data.documents.length > 0) {
    data.documents.forEach(obj => {
      if (obj.docType === PAN_NUMBER) {
        let panFieldType;
        if (data.accountType === INDIVIDUAL) {
          panFieldType = PAN_NAME;
        } else panFieldType = BUSINESS_PAN;
        data[panFieldType] = obj.docValue;
        initialErrorObj[panFieldType] = obj.remarks;
        initialTouchedObj[panFieldType] = true;
      }
      if (obj.docType.includes('_NUMBER'))
        data[[RELATED_DOCS_INPUT_MAPPING[obj.docType]]] = obj.docValue;
      if (obj.remarks) {
        initialErrorObj[[RELATED_DOCS_INPUT_MAPPING[obj.docType]]] =
          obj.remarks;
        initialTouchedObj[RELATED_DOCS_INPUT_MAPPING[obj.docType]] = true;
      }
    });
  }
};

const populateBusinessType = (business, data) => {
  if (business !== '') {
    data.businessType = parseInt(
      Object.keys(BUSINESS_TYPE_MAPPING).find(
        key => BUSINESS_TYPE_MAPPING[key] === business,
      ),
      10,
    );
  }
};

const populateKycDocs = data => {
  if (data.documents.length > 0) {
    data.documents.forEach(doc => {
      if (doc.docType === PAN) {
        let panFieldType;
        if (data.accountType === INDIVIDUAL) {
          panFieldType = PAN;
        } else panFieldType = BUSINESS_PAN_DOC;
        data.completeFileObj[panFieldType] = { name: doc.docValue };
      }
      if (POSSIBLE_KYC_DOCS.includes(doc.docType)) {
        data.completeFileObj[doc.docType] = { name: doc.docValue };
      }
    });
  }
};

export function KycForm({
  open,
  isEditMode,
  data = {},
  editModalLoading,
  modalErr,
  step,
  setStep,
  downloadDoc,
  handleKycDataPayload,
  merchantVendorId,
  accountType,
  setAccountType,
  addressProof,
  setAddressProof,
  kycFormData,
  setKycFormData,
  fileValidationErrors,
  setFileValidationErrors,
  isMerchantCritical,
  setIsKycDataFilled,
  detailsPageClicked,
}) {
  const [fileErrorObj, setFileErrorObj] = useState({});

  const divRef = useRef(null);

  const isDocOptional = !isMerchantCritical;

  let initialValues = {
    businessType: '',
    pan: '',
    uidai: '',
    passport: '',
    drivingLicense: '',
    voterId: '',
    gst: '',
    cin: '',
    businessPan: '',
    completeFileObj: {
      PAN: {},
      UIDAI_FRONT: {},
      UIDAI_BACK: {},
      DL: {},
      VOTER_ID: {},
      PASSPORT_FRONT: {},
      PASSPORT_BACK: {},
      NBFC_CERTIFICATE: {},
      businessPanDoc: {},
      GST: {},
      CIN: {},
    },
  };

  if (kycFormData) {
    initialValues = kycFormData;
  }

  const submitForm = (values, actions) => {
    const vendorPayload = { ...values };
    const isCritical = !isDocOptional;
    isDocsUploadedFunction(
      values.completeFileObj,
      values.businessType,
      values.addressProof,
      accountType,
    );
    const updatedPanValue =
      accountType === BUSINESS ? values.businessPan : values.pan;

    vendorPayload.pan = updatedPanValue;
    let updatedPayload = {};
    updatedPayload.businessType =
      BUSINESS_TYPE_MAPPING[values.businessType] || '';
    updatedPayload.accountType = accountType;
    POSSIBLE_KYC_PAYLOAD.forEach(value => {
      if (vendorPayload[value]) {
        updatedPayload[value] = vendorPayload[value];
      }
    });
    updatedPayload = filterUpdatedPayloadOnAccountType(
      updatedPayload,
      accountType,
    );

    if (accountType === INDIVIDUAL)
      updatedPayload = filterUpdatedPayloadOnAddress(
        updatedPayload,
        addressProof,
      );

    updatedPayload = filterUpdatedPayloadDocs(
      updatedPayload,
      addressProof,
      accountType,
    );
    handleKycDataPayload(updatedPayload, actions, isCritical, isDocUploaded);
  };

  const handleOptionalVendorTypeRadioOptions = obj => ({
    ...obj,
    checked: accountType === obj.value,
    onChange: () => {
      setAccountType(obj.value);
    },
  });

  const populateKycDocsErros = data => {
    const errorObj = {};
    if (data.documents.length > 0) {
      data.documents.forEach(doc => {
        if (POSSIBLE_KYC_DOCS.includes(doc.docType) && doc.remarks) {
          errorObj[doc.docType] = doc.remarks;
        }
        if (doc.docType === PAN && doc.remarks) {
          if (data.accountType === INDIVIDUAL) {
            errorObj.PAN = doc.remarks;
          } else {
            errorObj.businessPanDoc = doc.remarks;
          }
        }
      });
    }
    setFileErrorObj(errorObj);
  };

  const onCancelHandler = () => {
    setStep(0);
  };

  const uploadFileHandler = (completeFileObj, fieldValue) => {
    if (completeFileObj[fieldValue]) return completeFileObj[fieldValue];
    return {};
  };

  useEffect(() => {
    if (divRef.current) {
      divRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [divRef.current]);

  useEffect(() => {
    setIsKycDataFilled(true);
    if (isEditMode) {
      populateBusinessType(data.businessType, data);
      populateKycInputFields(data);
      setAccountType(data.accountType || BUSINESS);
      const { documents } = data;
      documents.forEach(doc => {
        ADDRESS_DOCS_API_RESPONSE.forEach((docVal, i) => {
          if (doc.docType === docVal) setAddressProof(i + 1);
        });
      });
      populateKycDocsErros(data);
    }
  }, []);

  if (isEditMode) {
    data.completeFileObj = initialValues.completeFileObj;
    populateKycDocs(data);
  }

  const handleFileChange = (e, fieldName) => {
    const [file] = e.target.files || e.dataTransfer.files;
    if (file) {
      const fileSize = file.size / (1024 * 1024);
      if (fileSize > FILE_SIZE) {
        const updatedErrors = { ...fileValidationErrors };
        updatedErrors[
          fieldName
        ] = `Maximum file size allowed is ${FILE_SIZE} MB.`;
        setFileValidationErrors(updatedErrors);
      } else if (fileValidationErrors[fieldName]) {
        delete fileValidationErrors[fieldName];
        setFileValidationErrors(fileValidationErrors);
      }
    }
    return file;
  };

  const showPreview = (fileObj, fieldName) => {
    if (fileObj) {
      if (fileObj[fieldName].type) {
        previewFile(URL.createObjectURL(fileObj[fieldName]));
      } else {
        if (fieldName === BUSINESS_PAN_DOC) {
          fieldName = PAN;
        }
        downloadDoc({
          data: { docType: fieldName, merchantVendorId },
          cb: response => {
            if (response.downloadUrl) {
              previewFile(response.downloadUrl);
            }
          },
        });
      }
    }
  };

  const showDocError = fieldName =>
    fileErrorObj[fieldName] ? fileErrorObj[fieldName] : null;

  const removeFieldError = fieldName => {
    const updatedErrorObj = fileErrorObj;
    delete updatedErrorObj[fieldName];

    setFileErrorObj(updatedErrorObj);
  };

  const removeFileValidationError = fieldName => {
    const updatedErrorObj = fileValidationErrors;
    delete updatedErrorObj[fieldName];

    setFileValidationErrors(updatedErrorObj);
  };

  const showErrorBorder = fieldName => {
    if (fileErrorObj[fieldName] || fileValidationErrors[fieldName]) return true;

    return false;
  };

  const onClickCrossHandler = () => {
    setStep(0);
  };
  return (
    <div>
      <Modal
        open={open}
        className="common-modal-wrapper add-vendorV2-wrapper"
        $maxWidth="480"
      >
        <ModalHeader>
          <div>
            <div className="heading">
              {`${isEditMode ? 'Edit' : 'Add '} Vendor`}
            </div>
          </div>
          <div
            className="close-modal"
            onClick={onClickCrossHandler}
            data-event-name="Form_KycForm_Icon_Close"
            data-ignore-inner-text="true"
            data-event-properties={JSON.stringify({ step })}
          >
            <CustomIcon componentName="CLOSE" />
          </div>
        </ModalHeader>
        <ModalContent>
          <Conditional if={!isDocOptional && !isEditMode}>
            <Space className="alert-info-space pt-1 pb-1">
              <div className="ml-4">
                <CustomIcon
                  width="18"
                  className="info"
                  componentName="ALERT_INFO"
                />
              </div>
              <Text variant="b14" className="alert-text ml-2" color="warning">
                Note: We recommend you to upload the mandatory KYC documents. If
                you wish to upload them later, use the Edit section from the
                dashboard.
              </Text>
            </Space>
          </Conditional>
          <div className="modal-content loading-modal">
            <Conditional if={editModalLoading}>
              <Loader active isModal paragraph={2} />
            </Conditional>
            {!editModalLoading && (
              <FormikComponent
                initialValues={
                  Object.keys(data).length === 0 ? initialValues : data
                }
                validationSchema={kycFormvalidationSchema(
                  accountType,
                  addressProof,
                  isEditMode,
                )}
                initialErrors={initialErrorObj}
                initialTouched={initialTouchedObj}
                onSubmit={submitForm}
              >
                {({
                  values = {},
                  handleFieldChange,
                  handleSubmit,
                  errors = {},
                  touched,
                  setFieldValue,
                  setFieldTouched,
                  setFieldError,
                  setTouched,
                  handleFieldBlur,
                  initialErrors,
                  ...formikProps
                }) => {
                  const disableField =
                    !formikProps.isValidating && formikProps.isSubmitting;
                  const errStep =
                    errors.pan ||
                    errors.uidai ||
                    errors.passport ||
                    errors.drivingLicense ||
                    errors.voterId ||
                    errors.gst ||
                    errors.cin ||
                    errors.addressProof ||
                    errors.businessPan;

                  const handleKeyPress = e => {
                    if (errStep || disableField || !values.vendorId) return;
                    if (e.charCode === 13) {
                      setStep(step + 1);
                    }
                  };

                  const resetUploadHandler = fieldName => {
                    setFieldValue(`completeFileObj.${[fieldName]}`, {});
                    removeFieldError(fieldName);
                    removeFileValidationError(fieldName);
                  };

                  const fileChangeHandler = (e, fieldName) => {
                    const file = handleFileChange(e, fieldName);
                    setFieldValue(`completeFileObj.${[fieldName]}`, file);
                  };

                  const onNavigateBackHandler = () => {
                    setKycFormData({ ...values });
                    setStep(step - 1);
                  };

                  if (kycFormData) {
                    initialValues = kycFormData;
                  }

                  return (
                    <form autoComplete="off" onSubmit={handleSubmit}>
                      <div className="scroll-bar">
                        <div
                          className="navigate-back"
                          onClick={onNavigateBackHandler}
                          data-event-name="Form_KycForm_Icon_Back"
                          data-ignore-inner-text="true"
                          data-event-properties={JSON.stringify({ step })}
                        >
                          <CustomIcon
                            componentName="CHEVRONDOWN"
                            direction="up"
                          />
                          <span>Back</span>
                        </div>
                        <Space justifyContent="space-between">
                          <Text variant="h16" strong className="mb-4">
                            KYC Details
                          </Text>
                          <span className="step">Step {step}/3</span>
                        </Space>
                        <Space alignItems="center">
                          <Text variant="b14" className="vendor-type">
                            Select Vendor Type
                          </Text>
                          <Popup
                            content={
                              <Text variant="b12" color="bodyLight">
                                Select Individual if vendor's annual turnover is
                                20 lakhs or lesser. Select Business Entity if
                                vendor's annual turnover is more than 20 lakhs.
                              </Text>
                            }
                            trigger={
                              <span className="pointer">
                                <CustomIcon componentName="INFO" />
                              </span>
                            }
                            position="top left"
                          />
                        </Space>

                        <RadioGroup
                          radioOptions={VENDOR_TYPE_RADIO_DATA.radioOptions.map(
                            handleOptionalVendorTypeRadioOptions,
                          )}
                        />

                        <div className="">
                          <Text
                            variant="b14"
                            color="bodyLight"
                            className="mb-1 mt-2"
                          >
                            Business Type
                          </Text>
                          <StyledBusinessTypeDropdown
                            errorBorder={!!errors?.businessType}
                          >
                            <Dropdown
                              fluid
                              name="businessType"
                              label="Business Type"
                              value={values.businessType}
                              placeholder="Select Business type"
                              options={BUSINESS_TYPE_OPTION}
                              errors={errors}
                              touched={touched}
                              onBlur={handleFieldBlur}
                              onChange={handleFieldChange}
                              disabled={disableField}
                              selection
                              icon="chevron down"
                            />
                          </StyledBusinessTypeDropdown>
                        </div>
                        {errors?.businessType && (
                          <Text color="danger" variant="b12">
                            {errors?.businessType}
                          </Text>
                        )}
                        <hr className="mt-4 mb-4" />

                        <Conditional if={accountType === INDIVIDUAL}>
                          <>
                            <InputField
                              fluid
                              id={PAN_NAME}
                              name={PAN_NAME}
                              label={
                                <Space
                                  className="mb-1"
                                  gap={1}
                                  alignItems="center"
                                >
                                  <Text variant="p14" color="bodyLight">
                                    {PAN}
                                  </Text>
                                  {!isMerchantCritical && (
                                    <Space className="sample-regex" gap={1}>
                                      <span>
                                        Eg.{' '}
                                        {SAMPLE_REGEX_INPUT_MAPPING[PAN_NAME]}
                                      </span>
                                      <CustomIcon
                                        componentName="COPY_TO_CLIPBOARD"
                                        handleClick={copyToClipboard(
                                          SAMPLE_REGEX_INPUT_MAPPING[PAN_NAME],
                                        )}
                                      />
                                    </Space>
                                  )}
                                </Space>
                              }
                              value={values.pan}
                              errors={errors}
                              touched={touched}
                              onBlur={handleFieldBlur}
                              onChange={handleFieldChange}
                              disabled={disableField}
                              className="mt-2"
                            />

                            <Space gap={2} className="mb-1 mt-3">
                              <Text variant="b14" color="bodyLight">
                                Upload PAN
                              </Text>
                              <Conditional if={isDocOptional}>
                                <span className="optional">Optional</span>
                              </Conditional>
                            </Space>
                            <FileUploadArea
                              name={PAN}
                              value={values.completeFileObj.PAN}
                              previewFile={() =>
                                showPreview(values.completeFileObj, PAN)
                              }
                              onChange={e => fileChangeHandler(e, PAN)}
                              onDrop={e => fileChangeHandler(e, PAN)}
                              checkList={GENERAL_FILE_CHECKLIST}
                              accept={VALID_FILE_FORMATS}
                              id={PAN}
                              uploadedFile={uploadFileHandler(
                                values.completeFileObj,
                                PAN,
                              )}
                              resetUpload={() => resetUploadHandler(PAN)}
                              uploadBtnContent="Choose a file"
                              fileError={fileValidationErrors.PAN}
                              errorBorder={showErrorBorder(PAN)}
                            />
                            <Text color="danger" variant="b12" className="mt-1">
                              {showDocError(PAN)}
                            </Text>

                            <div
                              className="select-with-custom-icon mt-3"
                              ref={divRef}
                            >
                              <Text
                                variant="b14"
                                color="bodyLight"
                                className="mb-1 mt-2"
                              >
                                Address Proof
                              </Text>
                              <Dropdown
                                fluid
                                className="primary-dropdown"
                                name="addressProof"
                                label="Address Proof"
                                value={addressProof}
                                placeholder="Select Address Proof"
                                options={ADDRESS_PROOF_OPTIONS}
                                errors={errors}
                                touched={touched}
                                onBlur={handleFieldBlur}
                                onChange={(e, data) => {
                                  setAddressProof(data.value);
                                  handleFieldChange(e, data);
                                }}
                                disabled={disableField}
                                selection
                                icon="chevron down"
                              />
                              {RENDER_INDIVIDUAL_FORM.map(obj => (
                                <Conditional
                                  if={addressProof === obj.addressProof}
                                >
                                  <InputField
                                    fluid
                                    id={obj.input.id}
                                    name={obj.input.name}
                                    label={
                                      <Space
                                        className="mb-1"
                                        gap={1}
                                        alignItems="center"
                                      >
                                        <Text variant="p14" color="bodyLight">
                                          {obj.input.label}
                                        </Text>
                                        {!isMerchantCritical && (
                                          <Space
                                            className="sample-regex"
                                            gap={1}
                                          >
                                            <span>
                                              Eg.{' '}
                                              {
                                                SAMPLE_REGEX_INPUT_MAPPING[
                                                  obj.input.name
                                                ]
                                              }
                                            </span>
                                            <CustomIcon
                                              componentName="COPY_TO_CLIPBOARD"
                                              handleClick={copyToClipboard(
                                                SAMPLE_REGEX_INPUT_MAPPING[
                                                  obj.input.name
                                                ],
                                              )}
                                            />
                                          </Space>
                                        )}
                                      </Space>
                                    }
                                    value={values[obj.input.name]}
                                    errors={errors}
                                    touched={touched}
                                    onChange={handleFieldChange}
                                    onBlur={handleFieldBlur}
                                    disabled={disableField}
                                    onKeyPress={handleKeyPress}
                                  />
                                  {obj.docs.map(doc => (
                                    <div key={doc}>
                                      <Space gap={2} className="mb-1 mt-3">
                                        <Text
                                          variant="b14"
                                          className="upload-pan"
                                          color="bodyLight"
                                        >
                                          {doc.text}
                                        </Text>
                                        <Conditional if={isDocOptional}>
                                          <span className="optional">
                                            Optional
                                          </span>
                                        </Conditional>
                                      </Space>
                                      <FileUploadArea
                                        name={doc.name}
                                        value={values[doc.name]}
                                        previewFile={() =>
                                          showPreview(
                                            values.completeFileObj,
                                            doc.name,
                                          )
                                        }
                                        onChange={e =>
                                          fileChangeHandler(e, doc.name)
                                        }
                                        onDrop={e =>
                                          fileChangeHandler(e, doc.name)
                                        }
                                        checkList={doc.checkList}
                                        accept={VALID_FILE_FORMATS}
                                        id={doc.id}
                                        uploadedFile={uploadFileHandler(
                                          values.completeFileObj,
                                          doc.name,
                                        )}
                                        resetUpload={() =>
                                          resetUploadHandler(doc.name)
                                        }
                                        uploadBtnContent="Choose a file"
                                        fileError={
                                          fileValidationErrors[doc.name]
                                        }
                                        errorBorder={showErrorBorder(doc.name)}
                                      />
                                      <Text
                                        color="danger"
                                        variant="b12"
                                        className="mt-1"
                                      >
                                        {showDocError(doc.name)}
                                      </Text>
                                    </div>
                                  ))}
                                </Conditional>
                              ))}
                            </div>
                          </>
                        </Conditional>
                        <Conditional if={accountType === BUSINESS}>
                          {RENDER_BUSINESS_FORM.map(obj => (
                            <div className="mt-3" key={obj.input.name}>
                              <InputField
                                fluid
                                id={obj.input.id}
                                name={obj.input.name}
                                label={
                                  <Space
                                    className="mb-1"
                                    gap={1}
                                    alignItems="center"
                                  >
                                    <Text variant="p14" color="bodyLight">
                                      {obj.input.label}
                                    </Text>
                                    {!isMerchantCritical && (
                                      <Space className="sample-regex" gap={1}>
                                        <span>
                                          Eg.{' '}
                                          {
                                            SAMPLE_REGEX_INPUT_MAPPING[
                                              obj.input.name
                                            ]
                                          }
                                        </span>
                                        <CustomIcon
                                          componentName="COPY_TO_CLIPBOARD"
                                          handleClick={copyToClipboard(
                                            SAMPLE_REGEX_INPUT_MAPPING[
                                              obj.input.name
                                            ],
                                          )}
                                        />
                                      </Space>
                                    )}
                                  </Space>
                                }
                                value={values[obj.input.name]}
                                errors={errors}
                                touched={touched}
                                onBlur={handleFieldBlur}
                                onChange={handleFieldChange}
                                disabled={disableField}
                              />
                              <Space gap={2} className="mb-1 mt-3">
                                <Text variant="b14" color="bodyLight">
                                  {obj.text}
                                </Text>
                                <Conditional if={isDocOptional}>
                                  <span className="optional">Optional</span>
                                </Conditional>
                              </Space>
                              <FileUploadArea
                                name={obj.docs.name}
                                value={values.completeFileObj.name}
                                previewFile={() =>
                                  showPreview(
                                    values.completeFileObj,
                                    obj.docs.name,
                                  )
                                }
                                onChange={e =>
                                  fileChangeHandler(e, obj.docs.name)
                                }
                                onDrop={e =>
                                  fileChangeHandler(e, obj.docs.name)
                                }
                                checkList={obj.docs.checkList}
                                accept={VALID_FILE_FORMATS}
                                id={obj.docs.id}
                                uploadedFile={uploadFileHandler(
                                  values.completeFileObj,
                                  obj.docs.name,
                                )}
                                resetUpload={() =>
                                  resetUploadHandler(obj.docs.name)
                                }
                                uploadBtnContent="Choose a file"
                                fileError={fileValidationErrors[obj.docs.name]}
                                errorBorder={showErrorBorder(obj.docs.name)}
                              />
                              <Text
                                color="danger"
                                variant="b12"
                                className="mt-1"
                              >
                                {showDocError(obj.docs.name)}
                              </Text>
                            </div>
                          ))}
                        </Conditional>
                        <Conditional if={values.businessType === 7}>
                          <Space gap={2} className="mt-3 mb-1">
                            <Text
                              variant="b14"
                              className="upload-pan"
                              color="bodyLight"
                            >
                              Upload NBFC Certificate
                            </Text>
                            <Conditional if={isDocOptional}>
                              <span className="optional">Optional</span>
                            </Conditional>
                          </Space>
                          <FileUploadArea
                            name={NBFC_CERTIFICATE}
                            value={values.completeFileObj.NBFC_CERTIFICATE}
                            previewFile={() =>
                              showPreview(
                                values.completeFileObj,
                                NBFC_CERTIFICATE,
                              )
                            }
                            onChange={e =>
                              fileChangeHandler(e, NBFC_CERTIFICATE)
                            }
                            onDrop={e => fileChangeHandler(e, NBFC_CERTIFICATE)}
                            checkList={GENERAL_FILE_CHECKLIST}
                            accept={VALID_FILE_FORMATS}
                            id={NBFC_CERTIFICATE}
                            uploadedFile={uploadFileHandler(
                              values.completeFileObj,
                              NBFC_CERTIFICATE,
                            )}
                            resetUpload={() =>
                              resetUploadHandler(NBFC_CERTIFICATE)
                            }
                            uploadBtnContent="Choose a file"
                            fileError={fileValidationErrors.NBFC_CERTIFICATE}
                            errorBorder={showErrorBorder(NBFC_CERTIFICATE)}
                            className="mt-2"
                          />
                          <Text color="danger" variant="b12" className="mt-1">
                            {showDocError(NBFC_CERTIFICATE)}
                          </Text>
                        </Conditional>
                      </div>
                      <div className="cta-wrapper btn-class">
                        <Button
                          link
                          type="button"
                          className="link"
                          onClick={onCancelHandler}
                          data-event-name="Form_KycForm_Button_Cancel"
                          data-event-properties={JSON.stringify({ step })}
                        >
                          Cancel
                        </Button>

                        {detailsPageClicked ? (
                          <Button
                            type="submit"
                            primary
                            loading={disableField}
                            disabled={
                              Object.keys(fileValidationErrors).length !== 0
                            }
                            data-event-name="Primary_Button_Save"
                          >
                            Save
                          </Button>
                        ) : (
                          <Button
                            type="submit"
                            primary
                            loading={disableField}
                            disabled={
                              Object.keys(fileValidationErrors).length !== 0
                            }
                            data-event-name={`Primary_Button_${
                              isEditMode
                                ? 'UpdateVendorDetails'
                                : 'AddVendorDetails'
                            }`}
                          >
                            {isEditMode
                              ? 'Update Vendor Details'
                              : 'Add Vendor Details'}
                          </Button>
                        )}
                      </div>
                      {modalErr && modalErr.message && (
                        <div className="modal-err-msg">{modalErr.message}</div>
                      )}
                    </form>
                  );
                }}
              </FormikComponent>
            )}
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
}

KycForm.propTypes = {
  open: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  editModalLoading: PropTypes.bool,
  modalErr: PropTypes.any,
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  handleKycDataPayload: PropTypes.func,
  downloadDoc: PropTypes.func,
  merchantVendorId: PropTypes.string,
  accountType: PropTypes.string.isRequired,
  setAccountType: PropTypes.func.isRequired,
  addressProof: PropTypes.string.isRequired,
  setAddressProof: PropTypes.func.isRequired,
  kycFormData: PropTypes.object.isRequired,
  setKycFormData: PropTypes.func.isRequired,
  fileValidationErrors: PropTypes.object.isRequired,
  setFileValidationErrors: PropTypes.func.isRequired,
  isMerchantCritical: PropTypes.bool.isRequired,
  setIsKycDataFilled: PropTypes.func.isRequired,
  detailsPageClicked: PropTypes.bool.isRequired,
};

export default memo(KycForm);
